import React, { Component } from 'react'
// connect方法的作用：将额外的props传递给组件，并返回新的组件，组件在该过程中不会受到影响
import { connect } from 'react-redux'
// 引入action
// import { setPageTitle } from '../../store/actions.js'
import "./index.css"
import { NetGet, NetPost } from '../../axios'
import ReactPaginate from 'react-paginate';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import 'react-toastify/dist/ReactToastify.css';
import Login from '../../components/com_login';
import LazyImg from '../../components/lazyimg';
import ReactMarkdown from 'react-markdown';
import * as Svg from '../../components/svg/svg';
import rehypeRaw from 'rehype-raw'
import EmojiView from '../../components/emoji/emoji';
import emjcof from '../../components/emoji/emojiconf'
import gfm from 'remark-gfm'
import {visit} from "unist-util-visit";
import paragraph  from '../../components/emoji/emojtanhtml'

let qq = ''


function myRehypePlugin() {
    return transform
    function transform(tree) {
      visit(tree, 'text', onText)
    }
    function onText(result) {
      var res = paragraph(result.value)
      result.value = res
    }
  }

// const customRenderers = {
//     // image: ({src, alt}) => {
//     //   return <a rel="nofollow" href={src}>{alt}</a>
//     // },
//     // link: ({href, children}) => {
//     //   return <a rel="nofollow" href={href}>{children[0]}</a>;
//     // },
//     paragraph: ({ children }) => {
//         var reslist = []
//         Array.from(children).forEach((e, i) => {
//             if (typeof (e.type.name) == "string") {
//                 var newValue = e.props.value


//                 // newValue = newValue.split(":emj-bili-"+item+":")
//                 // newValue = newValue.map((e, i) => <> <br /></>)


//                 // typeof newValue == 'object' && newValue.forEach((item) => {
//                 //     console.log("---", item)
//                 //     if (typeof (item.type.name) == "string") {
//                 //         item = item.split("\n")
//                 //         item = item.map((e, i) => <> { e}{(i !== newValue.length - 1) && <br />}</>)
//                 //     }

//                 // })

//                 newValue = newValue.split("\n")
//                 newValue = newValue.map((newe, i) => {
//                     emjcof.bili.text.forEach((item) => {
//                         if (newe.indexOf(':emj-bili-' + item.value + ':') >= 0) {
//                             console.log('有', emjcof)
//                             var exg = "/:emj-bili-" + item.value + ":/g"
//                             newe = newe.replace(eval(exg), biliImgEmj(item.value, item.det))
//                             //     newe = newe.split(":emj-bili-" + item + ":")
//                             //     newe = newe.map((e, i) => <>{e}{(i !== newValue.length - 1) &&<span class="emotion-inline emotion-item"
//                             //         style={{ marginLeft: " 0px", marginRight: "0px" }}>
//                             //         <img src="https://cdn.jsdelivr.net/gh/moezx/cdn@2.9.4/img/bili/xieyanxiao.png" class="img"
//                             //             style={{
//                             //                 animationDuration: "320ms",
//                             //                 animationTimingFunction: "steps(8)",
//                             //                 transform: "translateY(-224px)",
//                             //                 height: "256px"
//                             //             }} /></span>}</>)
//                         }
//                     })

//                     emjcof.tieba.text.forEach((item) => {

//                         if (newe.indexOf(':emj-tieba-' + item + ':') >= 0) {


//                             // var exg="/:emj-tieba-"+item+":/g" 
//                             // console.log(newe,newe.split(":emj-tieba-"+item+":"))
//                             newe = newe.split(":emj-tieba-" + item + ":").join(tiebaEmj(item));
//                             // newe=newe.replace(eval(exg),tiebaEmj(item))
//                             //     newe = newe.split(":emj-bili-" + item + ":")
//                             //     newe = newe.map((e, i) => <>{e}{(i !== newValue.length - 1) &&<span class="emotion-inline emotion-item"
//                             //         style={{ marginLeft: " 0px", marginRight: "0px" }}>
//                             //         <img src="https://cdn.jsdelivr.net/gh/moezx/cdn@2.9.4/img/bili/xieyanxiao.png" class="img"
//                             //             style={{
//                             //                 animationDuration: "320ms",
//                             //                 animationTimingFunction: "steps(8)",
//                             //                 transform: "translateY(-224px)",
//                             //                 height: "256px"
//                             //             }} /></span>}</>)
//                         }
//                     })

//                     return <> <emoji dangerouslySetInnerHTML={{ __html: newe }} />{(i !== newValue.length - 1) && <br />}</>

//                 })



//                 reslist.push(...newValue)
//             } else {
//                 reslist.push(e)
//             }
//         })

//         //console.log(children)
//         return <p >{reslist}</p>;
//     }
// }
class Data extends Component {

    state = {
        data: [],
        total: "获取中... ...",
        headimg: ""
    }
    focus = false
    page = 1



    componentDidMount() {

        this.getUserInfo()
        this.handlePageClick(this.page)
    }


    //获取用户信息 免重复填写
    getUserInfo = () => {
        var userinfo = Cookies.get('userinfo');
        if (userinfo) {
            var jsonuserinfo = JSON.parse(userinfo)
            try {
                this.setState({
                    headimg: jsonuserinfo.headimg,
                    uname: jsonuserinfo.uname, uemail: jsonuserinfo.uemail,
                    sidelink: jsonuserinfo.sidelink
                })
            } catch (error) {
                console.log("用户信息获取失败", error)
            }
        }
    }


    //input聚焦 pop 显示
    /**
     * @memberof Data
     * e:dom
     * bool:显示隐藏
     * reply:是否是回复的输入框
     * 
     */

    onpopShow = (e, bool, reply) => {
        if (e.target) {
            e.target.previousElementSibling.style.display = bool ? "block" : "none"
        }
        if (bool) {
            this.hiddenReInput(reply)
        }

    }


    // 设置定时器
    rotate = (e, code) => {



        var img = [...e.getElementsByTagName("img")]
        if (code) {
            img.map((e, i) => {
                e.style.transform = "rotate(360deg)"
            })
        } else {
            img.map((e, i) => {
                e.style.transform = "rotate(0deg)"
            })

        }



    }



    handlePageClick = (data) => {
        let page = data.selected >= 0 ? data.selected + 1 : 1;
        this.page = page
        let param = { page: page, limit: 10, articleid: this.props.articleid || 0 }

        NetGet("beltlist", param)
            .then((e) => {

                if (e.code == 0) {
                    if (this.focus) {
                        this.a.focus()
                    }
                    this.focus = true
                    this.setState({
                        data: e.data,
                        total: e.total
                    })
                    //    document.querySelectorAll(".beltBox").forEach((e,i)=>{
                    //     e.onmouseleave = (e)=> {
                    //         console.log("移入")
                    //         this.rotate(e.target,true)
                    //     }
                    //     e.onmouseout=(e)=>{
                    //         console.log("移出")
                    //         this.rotate(e.target,false)
                    //     }

                    //    })


                } else {
                    toast.error("留言获取失败 !");
                    this.setState({
                        total: "留言获取失败"
                    })
                }
            })
            .catch((err) => {
                console.log(err)
                toast.error("留言获取失败 !");
                this.setState({
                    total: "留言获取失败"
                })
            })
    }


    subClick = (ip, reply_id, to_uid, to_name) => {

        // const param = {body:'123',name:"米乃"}
        if (this.state.uname) {
            this.subdata(ip, reply_id, to_uid, to_name)

        } else {
            if (this.refs.inputname.value.length > 10) {
                return false
            }

            this.onBlur(ip).then(() => {
                this.subdata(ip, reply_id, to_uid, to_name)

            })
        }


    }

    IsURL = (strUrl) => {
        var regular = /^\b(((https?|ftp):\/\/)?[-a-z0-9]+(\.[-a-z0-9]+)*\.(?:com|edu|vip|wang|tech|mobi|work|store|live|ink|pub|group|cool|plus|zone|city|fit|website|world|link|auto|xyz|club|online|net|site|top|gov|int|mil|net|org|biz|info|name|museum|asia|coop|aero|[a-z][a-z]|((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]\d)|\d))\b(\/[-a-z0-9_:\@&?=+,.!\/~%\$]*)?)$/i
        if (regular.test(strUrl)) {
            return true;
        }
        else {
            return false;
        }
    }

    subdata = (ip, reply_id, to_uid, to_name) => {
        //用ip来判断是不是回复
        const token = Cookies.get('userinfo') ? JSON.parse(Cookies.get('userinfo')).token : ''
        //回复表单和留言表单区分开来  防止refs重叠 导致bug
        var replybol = typeof ip == 'string'
        const {
            reinputname,
            inputname,
            rebeltvalue,
            beltvalue,
            reinputemail,
            inputemail,
            inputsidelink,
            reinputsidelink
        } = this.refs
        let name = replybol ? reinputname.value : inputname.value
        let body = replybol ? rebeltvalue.value : beltvalue.value
        let email = replybol ? reinputemail.value : inputemail.value
        let sidelink = replybol ? (reinputsidelink.value || "") : (inputsidelink.value || '')
        let headimg = this.state.headimg
        if (!name || !body || !email) {
            return toast.error(`除了网站都必须填写哦~`);
        }
        if (sidelink) {
            if (!this.IsURL(sidelink)) {
                return toast.error(`请正确填写网站地址~`);
            }
        }

        var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
        if (!reg.test(email)) {
            return toast.error(`邮箱格式不对 !`);
        }

        let param = new URLSearchParams()
        param.append('number', qq)
        param.append('name', name)
        param.append('body', body)
        param.append('uemail', email)
        param.append('token', token)
        param.append('headimg', headimg ? headimg : '')
        param.append('articleid', this.props.articleid || 0)
        param.append('sidelink', sidelink)

        if (typeof ip == 'string') {

            param.append('reply_id', reply_id)
            param.append('to_uid', to_uid)
            param.append('to_name', to_name)


        }
        // alert(body)
        NetPost(typeof ip == 'string' ? ip : "addbelt", param)
            .then((e) => {
                if (e.code == 0) {
                    toast.success("留言成功 !");
                    let newData = this.state.data
                    this.handlePageClick(1)

                    try {
                        var statedata = JSON.parse(Cookies.get('userinfo'))
                        statedata.sidelink = sidelink
                        this.setState(statedata)
                        Cookies.set('userinfo', JSON.stringify(statedata), { expires: 1000 })

                    } catch (error) {

                    }


                    if (typeof ip == 'string') {
                        for (var i = 0; i < newData.length; i++) {
                            // if(newData[i].id==reply_id){
                            // const newreply={
                            //     name,
                            //     body,
                            //     time:"刚刚",
                            //     headimg,
                            //     to_name,
                            //     to_uid,
                            //     reply_id

                            // }
                            // newData[i].replylist.push(newreply)
                            this.setState({
                                // data:newData,
                                replyID: 0
                            })
                            // }
                        }

                    } else {

                        this.refs.beltvalue.value = ''

                        if (this.page != 1) {
                            this.setState({ headimg: '' })
                            return false
                        }
                        // this.handlePageClick(1)
                        // newData.unshift({
                        //     time: "刚刚",
                        //     name: name,
                        //     body: body,
                        //     headimg: headimg ? headimg : '',
                        //     replylist:[]
                        // })

                        // this.setState({
                        //     data: newData,
                        //     total: this.state.total + 1
                        //     //headimg: ``,
                        // })
                        //重置留言内容不清空其他


                    }
                } else {
                    if (e.code == -2) {
                        this.setState({
                            login: true
                        })
                    }
                    toast.error(e.msg);

                }


            })
            .catch((e) => {

                toast.error("留言失败 !");
            })
    }









    onBlur = () => {

        return new Promise((a, b) => {

            qq = this.refs.reinputname ? this.refs.reinputname.value : this.refs.inputname.value
            if (!qq) {
                return false
            }
            if (qq.length < 1) { return toast.error(`都必须填写 !`); }
            if (qq.length > 10) {
                return toast.error("昵称或qq号过长 !");
            }
            NetGet(`https://api.lixingyong.com/api/qq?id=${qq}`, {})
                .then((e) => {
                    // const reg = /^\w+\((\{[^()]+\})\)$/
                    // const matches = e.match(reg)
                    // matches匹配到的是数组，数组第一个是所有正则表达式匹配的字符串，第二个是第一个小括号匹配到的字符串
                    if (e) {

                        let data = e
                        var statedata = {
                            headimg: data.avatar ? data.avatar : undefined,
                            uname: data.nickname || undefined,
                            uemail: data.email ? data.email : undefined,
                            token: ''
                        }
                        try {
                            this.setState(statedata)
                            Cookies.set('userinfo', JSON.stringify(statedata), { expires: 1000 })
                        } catch (error) {

                        }


                    }
                    a(0)

                })
                .catch(() => {
                    b(1)
                })

        })



    }

    onChange = (e) => {
        if (this.state.uname) {
            this.setState({
                headimg: ``,
                uname: undefined
            })
        }

    }



    setLogin = () => {
        this.setState({
            login: false
        })
    }

    render() {

        return (
            <section style={{ maxWidth: "800px", margin: "auto", marginTop: "80px" }}>
                {this.renderForm()}

                <div style={{ marginTop: "90px" }}>
                    <a href="#comment" ref={(a) => this.a = a} refs="focusid" className="beltlength" style={{ outline: "none", textAlign: 'center' }}>Comments | {this.state.total >= 0 ? `${this.state.total}条${this.props.dataname || "留言"}` : this.state.total}</a>
                </div>


                <div className="commentBox">
                    {this.renderlist()}
                    {
                        Math.ceil(this.state.total / 10) > 0 &&
                        <ReactPaginate
                            previousLabel={'上一页'}
                            nextLabel={'下一页'}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={Math.ceil(this.state.total / 10)}//总页数
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={1}
                            onPageChange={this.handlePageClick}
                            containerClassName={'pagination'}
                            subContainerClassName={'pages pagination'}
                            activeClassName={'active'}
                        />
                    }

                </div>
                {
                    this.state.login && <Login setLogin={this.setLogin} />
                }
            </section>
        )
    }



    //一级留言
    renderlist = () => {
        const { data, replyID } = this.state
        var browtype = '', systemtype = ''
        return data.map((item, index) => {

            switch (item.browsertype) {
                case "Chrome":
                    browtype = <Svg.Chrome />
                    break;
                case "Safari":
                    browtype = <Svg.Safari />
                    break;
                case "ie":
                    browtype = <Svg.Ie />
                    break;

                case "Maxthon":
                    browtype = <Svg.Maxthon />
                    break;

                case "Edge":
                    browtype = <Svg.Edge />
                    break;
                case "UCWEB":
                    browtype = <Svg.Ucweb />
                    break;
                case "QQBrowser":
                    browtype = <Svg.QQBrowser />
                    break;
                case "sougou":
                    browtype = <Svg.Sogou />
                    break;
                case "Firefox":
                    browtype = <Svg.Firefox />
                    break;
                case "Opera":
                    browtype = <Svg.Opera />
                    break;

                case "360":
                    browtype = <Svg.Bro360 />
                    break;

                default:
                    browtype = <Svg.Unknow />
                    break;
            }


            switch (item.systemtype) {
                case "Mac":
                    systemtype = <Svg.Mac />
                    break;
                case "Windows":
                    systemtype = <Svg.Window />
                    break;
                case "Linux":
                    systemtype = <Svg.Linux />
                    break;

                case "Android":
                    systemtype = <Svg.Android />
                    break;

                case "iOS":
                    systemtype = <Svg.Mac />
                    break;


                default:
                    systemtype = <Svg.Unknow />
                    break;
            }

            var sidelinkto = item.sidelink ? (RegExp(/http:|https:/).test(item.sidelink) ? item.sidelink : "http://" + item.sidelink) : "javascript:;"
            return (
                <div className="beltBox" key={"belt" + index + 1}>
                    <div className="beltPeople">
                        <a className="peopleHeardere first" href={sidelinkto} {...sidelinkto != "javascript:;" && { target: "_target" }}>
                            <LazyImg loadimg="https://cdn.jsdelivr.net/gh/LIlGG/cdn@1.0.8/img/svg/loader/trans.ajax-spinner-preloader.svg" src={item.headimg ? item.headimg : require("../../img/defheader.png")} />
                        </a>
                        <div className="peopleInfo">
                            {
                                item.uemail == "839650216@qq.com" && <span title="Label: Pro" className="Label Label--purple mt-2 text-uppercase">
                                    博主
                                </span>
                            }
                            <a href={sidelinkto} {...sidelinkto != "javascript:;" && { target: "_target" }}><span>{item.name}</span></a>
                            {item.browsertype && <span className="ureagen brow">{browtype}<span>{item.browsertype}</span></span>}
                            {item.systemtype && <span className="ureagen">{systemtype}<span>{item.systemtype}</span></span>}
                            <div>发布于  {item.time}</div>
                        </div>
                        <div className="reply" onClick={() => {
                            this.setState({
                                replyID: replyID != "1" + item.id ? "1" + item.id : 0
                            })
                        }}
                        >
                            <a >回复</a>
                        </div>
                        <div class="comm-con">
                            <ReactMarkdown
                                skipHtml={false}
                    remarkPlugins={[gfm]}
                    rehypePlugins={[myRehypePlugin]}
                >
                    {typeof item.body === 'string' ? item.body.replace(/\n/g, '  \n') : item.body}
                </ReactMarkdown>
                        </div>

                        {/* <p>{item.body}</p> */}
                    </div>

                    <div className="beltext">
                        {this.renderReplylist(item.replylist, item.id)}
                        {replyID == "1" + item.id && this.renderForm(`回复${item.name}`, true, item.id, item.id, item.name)}
                    </div>


                </div>
            )
        })
    }

    //二级留言(留言的回复)
    renderReplylist = (data, reply_id) => {
        const { replyID } = this.state
        var browtype = ''
        var systemtype = ''
        return data && data.length > 0 ? data.map((item, index) => {
            switch (item.browsertype) {
                case "Chrome":
                    browtype = <Svg.Chrome />
                    break;
                case "Safari":
                    browtype = <Svg.Safari />
                    break;
                case "ie":
                    browtype = <Svg.Ie />
                    break;

                case "Maxthon":
                    browtype = <Svg.Maxthon />
                    break;

                case "Edge":
                    browtype = <Svg.Edge />
                    break;
                case "UCWEB":
                    browtype = <Svg.Ucweb />
                    break;
                case "QQBrowser":
                    browtype = <Svg.QQBrowser />
                    break;
                case "sougou":
                    browtype = <Svg.Sogou />
                    break;
                case "Firefox":
                    browtype = <Svg.Firefox />
                    break;
                case "Opera":
                    browtype = <Svg.Opera />
                    break;

                case "360":
                    browtype = <Svg.Bro360 />
                    break;

                default:
                    browtype = <Svg.Unknow />
                    break;
            }

            switch (item.systemtype) {
                case "Mac":
                    systemtype = <Svg.Mac />
                    break;
                case "Windows":
                    systemtype = <Svg.Window />
                    break;
                case "Linux":
                    systemtype = <Svg.Linux />
                    break;

                case "Android":
                    systemtype = <Svg.Android />
                    break;

                case "iOS":
                    systemtype = <Svg.Mac />
                    break;


                default:
                    systemtype = <Svg.Unknow />
                    break;
            }
            var sidelinkto = item.sidelink ? (RegExp(/http:|https:/).test(item.sidelink) ? item.sidelink : "http://" + item.sidelink) : "javascript:;"

            return (
                <div className="beltBox rebelt" key={"belt" + index} style={{ marginTop: index == 0 ? "-10px" : "10px" }}>
                    <div className="beltPeople">
                        <a className="peopleHeardere first" href={sidelinkto} {...sidelinkto != "javascript:;" && { target: "_target" }}>
                            <LazyImg loadimg="https://cdn.jsdelivr.net/gh/LIlGG/cdn@1.0.8/img/svg/loader/trans.ajax-spinner-preloader.svg" src={item.headimg ? item.headimg : require("../../img/defheader.png")} />
                        </a>
                        <div className="peopleInfo" >
                            {
                                item.uemail == "839650216@qq.com" && <span title="Label: Pro" className="Label Label--purple mt-2 text-uppercase">
                                    博主
                                </span>
                            }
                            <a href={sidelinkto} {...sidelinkto != "javascript:;" && { target: "_target" }}><span>{item.name}</span></a>
                            {item.browsertype && <span className="ureagen brow">{browtype}<span>{item.browsertype}</span></span>}
                            {item.systemtype && <span className="ureagen">{systemtype}<span>{item.systemtype}</span></span>}
                            <div>发布于  {item.time}</div>
                        </div>
                        <div className="reply" onClick={() => {

                            this.setState({ replyID: replyID != "2" + item.id ? "2" + item.id : 0 })
                        }}

                        >
                            <a >回复</a>
                        </div>
                    </div>

                    <div>
                        <div class="comm-con">
                            <span className="comment-at">{`@${item.to_name}`}</span>

                            <ReactMarkdown
                                skipHtml={false}
                    remarkPlugins={[gfm]}
                    rehypePlugins={[myRehypePlugin]}
                >
                    {typeof item.body === 'string' ? item.body.replace(/\n/g, '  \n') : item.body}
                </ReactMarkdown>
                        </div>
                        {replyID == "2" + item.id && this.renderForm(`${item.name}`, true, reply_id, item.id, item.name)}
                    </div>


                </div>
            )
        }) : null
    }

    replysubClicl = (reply_id, to_uid, to_name) => {
        // alert(`${reply_id},${to_uid},${to_name}`)
        this.subClick("addbeltreply", reply_id, to_uid, to_name)
    }


    hiddenReInput = (reply) => {

        if (!reply) {
            this.setState({ replyID: 0 })
        }


    }

    textareaonblur = () => {

        Array.from(document.querySelectorAll(".input-label")).forEach((e) => {
            if (e.previousElementSibling.value) {
                e.classList.add("focuslabel")
            } else {
                e.classList.remove("focuslabel")
            }

        })
    }

    changeShowpreview = (e) => {
        this.setState({ showpreview: e })
    }

    renderPreview = (e) => {
        const { showpreview } = this.state
        const data = this.refs[e] ? this.refs[e].value : ''
        if (showpreview) {


            // image: ({src, alt}) => {
            //   return <a rel="nofollow" href={src}>{alt}</a>
            // },
            // link: ({href, children}) => {
            //   return <a rel="nofollow" href={href}>{children[0]}</a>;
            // },
           

         
            
            return <div
                onClick={() => this.changeShowpreview(false)}
                className="preview"
                style={{ cursor: 'pointer' }}
            //style={{display:showpreview?"block":"none"}}
            >
                <ReactMarkdown
                    skipHtml={false}
                    remarkPlugins={[gfm]}
                    rehypePlugins={[myRehypePlugin]}
                >
                    {typeof data === 'string' ? data.replace(/\n/g, '  \n') : data}
                </ReactMarkdown>
            </div>
        } else {
            return null
        }


    }


    textChange = (e) => {
        const eTarget = e.target
        const prenode = eTarget.parentNode.querySelectorAll("button")[1]
        if (eTarget.value.length > 0) {
            prenode.style.display = "inline-block"
        } else {
            prenode.style.display = "none"
        }
    }


    onEmojiChoose = (e, reply) => {
        var textareaDom = this.refs[reply ? "rebeltvalue" : "beltvalue"]
        textareaDom.focus()
        let insert      = textareaDom.selectionStart;
        if (e.type == 'menhera') {
            textareaDom.value = textareaDom.value.substr(0, insert) + e.text+ textareaDom.value.substr(insert); 
            textareaDom.selectionStart = textareaDom.selectionEnd=insert+e.text.length;
        } else {
            var addemj = ":emj-" + e.type + "-" + e.text + ":"
            textareaDom.value = textareaDom.value.substr(0, insert) + addemj + textareaDom.value.substr(insert); 
            textareaDom.selectionStart = textareaDom.selectionEnd=insert+addemj.length;
        }
        
        
        textareaDom.nextElementSibling.classList.add("focuslabel")
        // textareaDom.querySelector(".input-label")[0].add("focuslabel")
    }

    renderForm = (title, reply, reply_id, to_uid, to_name) => {
        const { headimg, uname, uemail, showpreview, sidelink } = this.state

        const Textarea = <textarea
            onFocus={() => this.hiddenReInput(reply)}
            onBlur={this.textareaonblur}
            style={{ display: showpreview ? "none" : "block" }}
            className="textarea"
            name="beltvalue"
            autoFocus={reply}
            onChange={this.textChange}
            ref={reply ? "rebeltvalue" : "beltvalue"}
        />
        const userinfo = Cookies.get("userinfo") ? JSON.parse(Cookies.get("userinfo")) : ''
        return (
            <div className="comment-respond">
                <p style={{ fontStyle: "italic", marginBottom: "1rem" }}>
                    <a href="https://segmentfault.com/markdown" target="_blank">
                        <i className="iconfont icon-markdown" ></i>
                    </a>
                    Markdown Supported while <i className="fa fa-code" aria-hidden="true"></i> Forbidden
                 </p>

                <div style={{ position: "relative", margin: 'auto', display: "block", borderWidth: 1, borderColor: "#eee" }}>

                    {/* <div style={{ width: "100%", position: "absolute", paddingTop: "8px", paddingBottom: "8px", color: "#909090", fontSize: 13, fontWeight: "400", backgroundColor: "#f0f0f0", top: "1px", left: "1px", borderTopLeftRadius: "4px", borderTopRightRadius: "4px", padding: 0, height: "34px", lineHeight: "34px" }}>
                        {title && "回复"}{title ? <span className="comment-at">{title}</span> : "发表您的留言"}
                        </div> */}

                    {Textarea}
                    <label className="input-label">{showpreview ? "点击预览区域退出预览" : "你是我一生只会遇见一次的惊喜 ..."}</label>
                    {this.renderPreview(reply ? "rebeltvalue" : "beltvalue")}

                    <EmojiView onRef={e => this.emojiview = e} onEmojiChoose={(e) => this.onEmojiChoose(e, reply)} key={reply_id} />



                    <div className="input-box" >
                        <span className="qqHEader">
                            <img src={headimg ? headimg : require("../../img/defheader.png")} />
                            {/* <LazyImg loadimg="https://cdn.jsdelivr.net/gh/LIlGG/cdn@1.0.8/img/svg/loader/trans.ajax-spinner-preloader.svg"  src={headimg ? headimg : require("../../img/defheader.png")} /> */}

                        </span>
                        <div className="display">
                            <div>
                                {<span className="popuptext" id="thePopup">输入QQ号将自动拉取头像和昵称</span>}
                                <input
                                    onBlur={(e) => { this.onpopShow(e, false); this.onBlur() }}
                                    onChange={this.onChange}
                                    onFocus={(e) => this.onpopShow(e, true, reply)}
                                    placeholder="输入QQ号" className="inputname" value={uname} type="text" ref={reply ? "reinputname" : "inputname"} size="22" autoComplete="off" tabIndex="1" aria-required="true" style={{ marginRight: "10px" }} />
                            </div>

                            <div>
                                {<span className="popuptext" id="emiPopup">你将收到邮箱回复通知</span>}
                                <input
                                    onBlur={(e) => { this.onpopShow(e, false) }}
                                    onChange={() => { if (uemail) { this.setState({ uemail: undefined }) } }}
                                    value={uemail}
                                    onFocus={(e) => this.onpopShow(e, true, reply)}
                                    placeholder="邮箱地址" className="inputname" type="text" ref={reply ? "reinputemail" : "inputemail"} size="22" autoComplete="off" tabIndex="1" aria-required="true" />
                            </div>

                            <div>
                                {<span className="popuptext" id="linkPopup">禁止广告哦~！</span>}
                                <input
                                    onBlur={(e) => { this.onpopShow(e, false) }}
                                    onChange={() => { if (sidelink) { this.setState({ sidelink: undefined }) } }}
                                    value={sidelink ? sidelink : undefined}
                                    onFocus={(e) => this.onpopShow(e, true, reply)}
                                    placeholder="网站(选填)" className="inputname" type="text" ref={reply ? "reinputsidelink" : "inputsidelink"} size="22" autoComplete="off" tabIndex="1" aria-required="true" />
                            </div>
                        </div>

                    </div>

                    <button type="button" ref="gb_bt" className="gb_bt" onClick={reply ? () => this.replysubClicl(reply_id, to_uid, to_name) : this.subClick} id="btnPostMsg">发表</button>

                    <button type="button"
                        ref="showpre_bt"
                        className="gb_bt"
                        onClick={() => { this.setState({ showpreview: !showpreview }) }}
                        style={{ marginLeft: "15px", display: "none" }}
                    >
                        {showpreview ? "编辑" : "预览"}
                    </button>

                </div>
            </div>
        )
    }

}



export default connect()(Data)